import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "form-field" }
const _hoisted_2 = {
  key: 0,
  class: "hint"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "required"
}
const _hoisted_6 = {
  key: 0,
  class: "help"
}
const _hoisted_7 = {
  key: 1,
  class: "hint"
}
const _hoisted_8 = { class: "label" }
const _hoisted_9 = ["value", "name", "checked", "onChange"]
const _hoisted_10 = {
  key: 2,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
        _ctx.$slots.hint &&
        _ctx.schema.hintPosition === 'top' &&
        _ctx.field.type !== 'checkbox' &&
        _ctx.field.type !== 'radio'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.options && _ctx.options.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_ctx.field.hideLabel)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                _renderSlot(_ctx.$slots, "label", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.field.label ? _ctx.field.label : " ") + " ", 1),
                  (_ctx.field.label && _ctx.field.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                    : _createCommentVNode("", true)
                ], true),
                (_ctx.hasHelpSlot)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_icon, { icon: "info" }),
                      _createElementVNode("div", {
                        class: _normalizeClass(["tooltip", _ctx.field.tooltipLocation])
                      }, [
                        _renderSlot(_ctx.$slots, "help", {}, () => [
                          _cache[0] || (_cache[0] = _createTextVNode(" Shalom from the tooltip! ", -1))
                        ], true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.hint && _ctx.schema.hintPosition === 'top')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _mergeProps(_ctx.$attrs, { class: "radio-btns-container" }), [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("label", {
                key: option.value,
                class: "radio-container"
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(option.label ? option.label : ""), 1),
                _createElementVNode("input", _mergeProps({
                  type: "radio",
                  ref_for: true,
                  ref: "radioInput",
                  value: option.value,
                  name: _ctx.field.label || 'radio-group',
                  checked: (_ctx.modelValue as any),
                  onChange: ($event: any) => {
              _ctx.$emit('update:modelValue', option.value !== undefined ? option.value : option);
              _ctx.validate(_ctx.schema, ($event.target as any).checked, _ctx.compare);
            }
                }, { ref_for: true }, _ctx.$attrs), null, 16, _hoisted_9),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]))
            }), 128))
          ], 16)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.hint && _ctx.schema.hintPosition === 'bottom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      class: _normalizeClass(["invalid-feedback", {
        multiple: _ctx.schema.errors && _ctx.schema.errors.length > 1,
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema.errors, (error, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
      }), 128))
    ], 2)
  ]))
}